import { HammerIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { ComingSoonDialog } from '@/components/molecules/coming-soon-dialog.molecule'

import { TOOLS_COMING_SOON_CONFIG } from './coming-soon-features.config'
import type { DialogState } from './use-coming-soon-dialogs.hook'

interface ComingSoonDialogsProps {
  toolsDialog: DialogState
}

export const ComingSoonDialogs = ({ toolsDialog }: ComingSoonDialogsProps): ReactNode => (
  <ComingSoonDialog
    isOpen={toolsDialog.isOpen}
    onOpenChange={toolsDialog.onOpenChange}
    title={TOOLS_COMING_SOON_CONFIG.title}
    description={TOOLS_COMING_SOON_CONFIG.description}
    featureList={TOOLS_COMING_SOON_CONFIG.featureList}
    icon={<HammerIcon className="size-5 text-amber-500" />}
  />
)
